const { expect } = require('chai');
const { jpath } = require('jsonpath-mapper');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Copy the content of a field', () => {
  describe('preview copying a simple string field', () => {
    const mock = loadRecordedMock('copy_field_simple_string_preview.json');
    const n = 20;

    it(`should return ${n} entries to update`, (done) => {
      migratortronApi.post(
        'copy/field?simple&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('copy a simple string field', () => {
    const mock = loadRecordedMock('copy_field_commit_simple_string.json');
    const n = 20;

    it(`should update ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?simple&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('repeat the same copy a simple string field', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_simple_string_repeat.json'
    );
    const n = 20;

    it(`should return ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?simple&string&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(n);
          expect(jpath('existing.*.totalCount', body)).to.equal(n);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview copying a simple array field', () => {
    const mock = loadRecordedMock('copy_field_simple_array_preview.json');
    const n = 20;

    it(`should return ${n} entries to update`, (done) => {
      migratortronApi.post(
        'copy/field?simple&array',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('copy a simple array field', () => {
    const mock = loadRecordedMock('copy_field_commit_simple_array.json');
    const n = 20;

    it(`should update ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?simple&array',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('repeat the same copy a simple array field', () => {
    const mock = loadRecordedMock('copy_field_commit_simple_array_repeat.json');
    const n = 20;

    it(`should return ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?simple&array&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(n);
          expect(jpath('existing.*.totalCount', body)).to.equal(n);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview copying string to an array field', () => {
    const mock = loadRecordedMock('copy_field_array_string_preview.json');
    const n = 20;

    it(`should return ${n} entries to update`, (done) => {
      migratortronApi.post(
        'copy/field?array&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('copy string to an array field', () => {
    const mock = loadRecordedMock('copy_field_commit_array_string.json');
    const n = 20;

    it(`should update ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?array&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('repeat the same copy string to an array field', () => {
    const mock = loadRecordedMock('copy_field_commit_array_string_repeat.json');
    const n = 20;

    it(`should return ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?array&string&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(n);
          expect(jpath('existing.*.totalCount', body)).to.equal(n);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview copying an array to a string field', () => {
    const mock = loadRecordedMock('copy_field_flatten_array_preview.json');
    const n = 18;

    it(`should return ${n} entries to update`, (done) => {
      migratortronApi.post(
        'copy/field?flatten&array',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('copy array to a string field', () => {
    const mock = loadRecordedMock('copy_field_commit_flatten_array.json');
    const n = 18;

    it(`should update ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?flatten&array',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('repeat the same copy array to a string field', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_flatten_array_repeat.json'
    );
    const n = 20;

    it(`should return ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?flatten&array&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(n);
          expect(jpath('existing.*.totalCount', body)).to.equal(n);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview copying with a missing required input', () => {
    const mock = loadRecordedMock('copy_field_noinput_preview.json');

    it(`should return an error saying required input is missing`, (done) => {
      migratortronApi.post(
        'copy/field?nosource',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(response.statusCode).to.equal(422);
          expect(body && typeof body === 'object').to.be.true;
          expect(body.error?.message).to.exist;
          expect(body.error.message).to.contain('required');
          done();
        }
      );
    });
  });

  describe('preview copying a non-existing source field', () => {
    const mock = loadRecordedMock('copy_field_nosource_preview.json');

    it(`should return an error saying field is not found`, (done) => {
      migratortronApi.post(
        'copy/field?nosource',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(response.statusCode).to.equal(422);
          expect(body && typeof body === 'object').to.be.true;
          expect(body.error?.message).to.exist;
          expect(body.error.message).to.contain('Did not find a field with id');
          done();
        }
      );
    });
  });

  describe('preview copy to a non-existing destination field', () => {
    const mock = loadRecordedMock('copy_field_nodestination_preview.json');

    it(`should return an error saying field is not found`, (done) => {
      migratortronApi.post(
        'copy/field?nodestination',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(response.statusCode).to.equal(422);
          expect(body && typeof body === 'object').to.be.true;
          expect(body.error?.message).to.exist;
          expect(body.error.message).to.contain('Did not find a field with id');
          expect(body.error.message).to.contain('in target');
          done();
        }
      );
    });
  });

  describe('preview copying an incompatible field', () => {
    const mock = loadRecordedMock('copy_field_incompatible_preview.json');

    it(`should return an error saying can not transform field`, (done) => {
      migratortronApi.post(
        'copy/field?incompatible',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(response.statusCode).to.equal(422);
          expect(body && typeof body === 'object').to.be.true;
          expect(body.error?.message).to.exist;
          expect(body.error.message).to.contain('Can not transform');
          done();
        }
      );
    });
  });
});
